document.addEventListener('DOMContentLoaded', () => {
	const searchIcon = document.querySelector<HTMLAnchorElement>('.js-search-toggle');
	const searchForm = document.querySelector<HTMLElement>('.search_it-form');
	const searchInput = searchForm?.querySelector<HTMLInputElement>('input[name="search"]');
	const isDesktopXL = window.matchMedia('(min-width: 1280px)');
	const megamenu = document.querySelector<HTMLElement>('.js-megamenu-expandable');
	const mobileNav = document.querySelector('.megamenu__mobile-nav');

	if (!searchIcon || !searchForm) return;

	// Toggle Suche
	searchIcon.addEventListener('click', (e) => {
		if (!megamenu || !mobileNav) return;

		// Megamenu + Mobile Nav öffnen
		megamenu.classList.add('is-open');
		mobileNav.classList.add('is-open');
		document.body.classList.add('no-body-scrolling'); // Scroll sperre wie beim Menü-Icon

		// Wenn Desktop XL, dann Suche automatisch offen
		if (isDesktopXL.matches) return;

		e.preventDefault();
		searchForm.classList.toggle('is-open');

		if (searchForm.classList.contains('is-open') && searchInput) {
			searchInput.focus();
		}
	});

	if (megamenu) {
		const observer = new MutationObserver(() => {
			if (!isDesktopXL.matches) return;

			if (megamenu.classList.contains('is-open')) {
				searchForm.classList.add('is-open');
				searchInput?.focus();
			} else {
				searchForm.classList.remove('is-open');
			}
		});

		observer.observe(megamenu, {
			attributes: true,
			attributeFilter: ['class'],
		});
	}

	const handleResize = () => {
		if (isDesktopXL.matches && megamenu?.classList.contains('is-open')) {
			searchForm.classList.add('is-open');
			searchInput?.focus();
		}
	};
	window.addEventListener('resize', handleResize);

	// Form schließen bei Klick außerhalb oder ESC
	searchForm.addEventListener('click', (e) => {
		if (e.target === searchForm) {
			searchForm.classList.remove('is-open');
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') searchForm.classList.remove('is-open');
	});

	// === NEU: Suche schließen, wenn Menü geöffnet wird ===
	const menuToggle = document.querySelector<HTMLElement>('.js-megamenu-toggle');
	const level1Links = document.querySelectorAll<HTMLElement>(
		'.megamenu__header--list a[data-main-nav-id], .megamenu__mobile-nav--list button'
	);

	// Wenn Menü-Icon geklickt wird
	menuToggle?.addEventListener('click', () => {
		searchForm.classList.remove('is-open');
	});

	// Wenn Level-1 oder Mobile-Nav geklickt wird
	level1Links.forEach((link) => {
		link.addEventListener('click', () => {
			searchForm.classList.remove('is-open');
		});
	});

	function closeMenu() {
		const megamenu = document.querySelector('.js-megamenu-expandable');
		const mobileNav = document.querySelector('.megamenu__mobile-nav');
		megamenu.classList.remove('is-open');
		mobileNav?.classList.remove('is-open');
		document.body.classList.remove('no-body-scrolling');

		document.querySelectorAll('.is-selected').forEach((element) => {
			element.classList.remove('is-selected');
		});
	}

	handleResize();
});
